import React, { useMemo } from 'react';
import { Dialog, Flex, Pane, PropertyGrid } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { Config } from '@leverege/plugin';
import { PuffLoader } from 'react-spinners';
import Attributes from "../Attributes.js";
import AttributeValueEditors from "./AttributeValueEditors.js";
import AttributeGridError from "./AttributeGridError.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const {
  t
} = I18N.ns('ui-attributes.attribute.editor.AttributeForm');
export default function AttributeForm({
  active,
  applying,
  attributes,
  context,
  errors,
  errorVariant,
  highlightErrors,
  object,
  onChange,
  target,
  validating,
  value: values,
  variant,
  validator,
  onCancel
}) {
  const Loader = Config.get('LoadingView', 'spinner', PuffLoader);
  const loaderProps = Config.get('LoadingView', 'props', {});
  const editableAttributes = useMemo(() => {
    return attributes.filter(attr => {
      const {
        name
      } = attr;
      return Attributes.canSet(name, target, undefined, context);
    });
  }, [attributes, context, target]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(PropertyGrid, {
      variant: variant || 'attributeEditor',
      vertical: true,
      children: [editableAttributes.length > 0 ? editableAttributes.map((attr, idx) => {
        const {
          name,
          options
        } = attr;
        if (Attributes.canSet(name, target, undefined, context)) {
          const editor = AttributeValueEditors.getEditorFor(name, target);
          if (editor == null) {
            return null;
          }
          const attribute = Attributes.getAttribute(name, target.type);
          const displayName = Attributes.getDisplayName(name, target.type);
          const value = values[name];
          const key = `${name}-${idx}`;
          const vis = active[name] !== false;
          const props = {
            ...options,
            object,
            editable: true,
            key,
            eventData: name,
            attribute,
            value,
            formValues: values,
            onChange,
            onCancel,
            context,
            usage: 'form',
            error: errors?.fieldErrors?.[name]
          };
          // if ( !vis ) { props.style = { visibility : 'hidden' } }
          if (!vis) {
            props.disabled = true;
          }
          return /*#__PURE__*/_jsx(PropertyGrid.Item, {
            stretch: true,
            label: validator.decorateLabel(name, displayName),
            children: /*#__PURE__*/_jsxs(Flex, {
              direction: "column",
              children: [editor.create(props), /*#__PURE__*/_jsx(AttributeGridError, {
                highlight: highlightErrors,
                error: errors?.fieldErrors?.[name],
                variant: errorVariant
              })]
            })
          }, name);
        }
        return null;
      }) : t('noAttributeWarning', {
        objectType: target?.type
      }), errors?.formErrors?.length > 0 && /*#__PURE__*/_jsx(PropertyGrid.Item, {
        stretch: true,
        children: /*#__PURE__*/_jsx(Flex, {
          direction: "column",
          children: errors.formErrors.map(err => {
            return /*#__PURE__*/_jsx(AttributeGridError, {
              error: err,
              variant: errorVariant
            });
          })
        })
      })]
    }), /*#__PURE__*/_jsx(Dialog, {
      show: validating || applying,
      children: /*#__PURE__*/_jsxs(Pane, {
        variant: "formLoadingView|loadingView|loadingScreen",
        layout: "flex:colMCenter",
        children: [applying ? context?.isCreate ? t('creating', {
          name: context?.clientProps?.relationship?.blueprint?.name || 'Device'
        }) : t('updating', {
          name: context?.clientProps?.relationship?.blueprint?.name || 'Device'
        }) : t('validating'), /*#__PURE__*/_jsx(Loader, {
          ...loaderProps
        })]
      })
    })]
  });
}